import type { PopperProps as MuiPopperProps } from '@material-ui/core/Popper'

/**
 * Gap (px) kept between the desktop date picker popper and the viewport edge.
 * `popperScroll` in useDatePickerStyles caps the popper at `100vh - 2 × this`
 * so a calendar taller than the window still fits and scrolls.
 */
export const DATE_PICKER_VIEWPORT_PADDING = 8

/**
 * Popper.js modifiers for the desktop date picker popper.
 *
 * The calendar used to open straight down with `flip` disabled, so on shorter
 * windows the last weeks of the month sat below the viewport and could not be
 * clicked (#24468, and ENG-860 for one call site). `flip` opens it above the
 * input when there is no room below; `preventOverflow` clamps it inside the
 * viewport.
 */
export const DATE_PICKER_POPPER_MODIFIERS = {
  flip: {
    enabled: true,
    boundariesElement: 'viewport'
  },
  preventOverflow: {
    enabled: true,
    boundariesElement: 'viewport',
    padding: DATE_PICKER_VIEWPORT_PADDING
  }
}

/**
 * Default `PopperProps` for the shared date pickers. `overrides` win, and an
 * override `modifiers` replaces the defaults whole (not merged), so call sites
 * that already pass their own modifiers keep their behaviour.
 *
 * `disablePortal` stays true so the popper renders inside its dialog (focus
 * trap and click-away keep working).
 */
export function getDatePickerPopperProps(
  anchorEl: MuiPopperProps['anchorEl'],
  overrides?: Partial<MuiPopperProps>
): Partial<MuiPopperProps> {
  return {
    anchorEl,
    placement: 'bottom-start',
    modifiers: DATE_PICKER_POPPER_MODIFIERS,
    disablePortal: true,
    ...overrides
  }
}
